module.exports = __webpack_public_path__ + "static/img/bj.96dcc5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bj.png
// module id = FTau
// module chunks = 1